var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import classNames from 'classnames';
import FlagCondition from 'components/common/flag-condition/FlagCondition';
import PageHeader from 'components/common/page-header/PageHeader';
import withResizeScreen from 'components/common/with-resize-screen/withResizeScreen';
import { FeatureFlagNames } from 'constants/app.constant';
import CWPageNavigator from 'reports/cw/components/common/cw-page-navigator/CWPageNavigator';
export var CW_UPDATED_HEADER_TITLE = 'Performance & Grades Dashboard';
// CWPageNavigator only renders on desktop, and PageHeader's new-header layout is desktop-only too,
// so on mobile navigation has to stay on the legacy hamburger + PageNavigator modal.
var CWUpdatedPageHeaderBase = function (_a) {
    var showNavigation = _a.showNavigation, currentAppLinkPage = _a.currentAppLinkPage, customClass = _a.customClass, windowMode = _a.windowMode, restProps = __rest(_a, ["showNavigation", "currentAppLinkPage", "customClass", "windowMode"]);
    return (<>
    <PageHeader {...restProps} title={CW_UPDATED_HEADER_TITLE} newHeaderShown showNavigation={showNavigation && windowMode.mobile} customClass={classNames('c-cw-page-header--updated', customClass)}/>
    {showNavigation && <CWPageNavigator currentAppLinkPage={currentAppLinkPage}/>}
  </>);
};
var CWUpdatedPageHeader = withResizeScreen(CWUpdatedPageHeaderBase);
var CWPageHeader = function (props) { return (<FlagCondition featureFlagName={FeatureFlagNames.CW_UPDATED_UI_ENABLED} trueStatement={<CWUpdatedPageHeader {...props}/>} falseStatement={<PageHeader {...props}/>}/>); };
export { CWUpdatedPageHeader, CWUpdatedPageHeaderBase };
export default CWPageHeader;
